import { Dialog, DialogTitle, DialogContent, Grid, DialogActions, DialogContentText, MenuItem, FormControl, TextField, TextareaAutosize } from "@mui/material"
import { addModalCalendar } from "../../../mock-data/Calendar-mock-data";
import { useState } from "react"
const CalendarViewModal = (props: any) => {
    const { showAddModal, setShowAddModal } = props;
    const [inputValue, setInputValue] = useState({ name: '', description: '', templateCalendar: '' });
    const handleChange = (e: any) => {
        setInputValue({ ...inputValue, [e.target.name]: e.target.value })
    }
    console.log(inputValue);

    return (
        <div>
            <Dialog
                className="view-calendar-modal"
                open={showAddModal}
                onClose={() => setShowAddModal(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" className='Department-background fw-600 '
                    sx={{ fontSize: "16px", mb: 3, }}>
                    <p> Add New Calendar</p>
                </DialogTitle>
                <DialogContent className='content'>
                    <DialogContentText id="alert-dialog-description">
                        <Grid container>
                            <Grid item md={12} xs={12} display='flex' flexDirection='column'>
                                <label>Calendar Name <span>*</span></label>
                                <TextField
                                    size="small"
                                    value={inputValue.name}
                                    name="name"
                                    onChange={handleChange}
                                    type="text"
                                    placeholder="Enter Name"
                                    sx={{
                                        mb: "20px", '& label.Mui-focused': {
                                            color: '#F78812',
                                        },
                                        '& .MuiInput-underline:after': {
                                            borderBottomColor: '#F78812',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: '#CCCCCC',
                                            },
                                            '&:hover fieldset': {
                                                borderColor: '#F78812',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: '#F78812',
                                            },
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item md={12} xs={12} display='flex' flexDirection='column'>
                                <label className='text-color fw-500 fs-14'>Description</label>
                                <TextareaAutosize minRows={3} className='input' placeholder='Write somthing' style={{ borderRadius: "4px", paddingTop: '10px', fontSize: '16px', paddingLeft: '15px', marginBottom: "20px",
                                borderColor:""
                            }} value={inputValue.description} name="description" onChange={handleChange} />
                            </Grid>
                            <Grid item md={12} xs={12} display='flex' flexDirection='column'>
                                <FormControl>
                                    <label className="fw-500 ">Account Owner <span >*</span></label>
                                    <TextField
                                        select
                                        size="small"
                                        value={inputValue.templateCalendar}
                                        name="templateCalendar"
                                        onChange={handleChange}
                                        placeholder="Selcet"
                                        sx={{
                                            '& label.Mui-focused': {
                                                color: '#F78812',
                                            },
                                            '& .MuiInput-underline:after': {
                                                borderBottomColor: '#F78812',
                                            },
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: '#CCCCCC',
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: '#F78812',
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: '#F78812',
                                                },
                                            },
                                        }}

                                    >
                                        {addModalCalendar.map((item: any) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                    </TextField>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Grid item md={12} xs={6}>
                        <button className='btn cancel text-color btn-light-grey' onClick={() => setShowAddModal(false)}>Cancel</button>
                        <button className='btn cancel save btn-secondary' onClick={() => setShowAddModal(false)}>Save</button>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>
    )
}
export default CalendarViewModal